import { render, staticRenderFns } from "./RiseupGoalDonePopup.vue?vue&type=template&id=5b474343"
import script from "./RiseupGoalDonePopup.vue?vue&type=script&lang=js"
export * from "./RiseupGoalDonePopup.vue?vue&type=script&lang=js"
import style0 from "./RiseupGoalDonePopup.vue?vue&type=style&index=0&id=5b474343&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports